import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=4f88f115"
import script from "./ListSkeleton.vue?vue&type=script&lang=js"
export * from "./ListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports